import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DatetimePickerModalComponent } from './datetime-picker.component';
import { Observable} from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable()

export class DatetimePickerModalService {
  constructor(
    private modal: BsModalService,
  ) { 
  }
  open(title:string, default_value:number = null, min_value:number = null, max_value:number = null):Observable<number> {
    const modal:BsModalRef = this.modal.show(DatetimePickerModalComponent, {initialState:{title, default_value, min_value, max_value}}); 
    return modal.content.action.pipe(
      take(1),
    )
  }
}
